module.exports = __webpack_public_path__ + "assets/img/title-83bb7da8.png";